import { useState } from 'react';

export default function Donation() {
  const [showWakafModal, setShowWakafModal] = useState(false);

  const donationMethods = [
    {
      icon: 'ri-bank-line',
      title: 'Pindahan Bank',
      bank: 'Maybank',
      account: '551342117467',
      name: 'Badan Kebajikan Zawiyah Johor Bahru'
    },
    {
      icon: 'ri-wallet-line',
      title: 'eWallet',
      details: [
        'Touch n Go: ',
        'GrabPay: ',
        'Boost: '
      ],
      link: 'https://badankebajikanzawiyahjohor.bcl.my/form/sumbangan-tabung-pembangunan-madrasah-tahfiz-al-quran-zawiyah-darul-madad'
    },
    {
      icon: 'ri-qr-code-line',
      title: 'QR Payment',
      description: 'Imbas kod QR untuk derma',
      link: 'https://badankebajikanzawiyahjohor.bcl.my/form/sumbangan-tabung-pembangunan-madrasah-tahfiz-al-quran-zawiyah-darul-madad'
    }
  ];

  return (
    <>
      <section id="infaq" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">Infaq & Sumbangan</h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Sumbangan anda membantu melahirkan generasi huffaz yang cemerlang
            </p>
          </div>

          <div className="bg-gradient-to-br from-emerald-700 to-emerald-900 rounded-2xl p-8 md:p-12 text-white mb-16">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-4">Mengapa Menyumbang?</h3>
                <p className="text-emerald-100 mb-6 leading-relaxed">
                  Setiap sumbangan anda adalah pelaburan untuk akhirat. Dengan menyumbang, anda turut sama melahirkan huffaz yang akan menyebarkan cahaya Al-Quran kepada ummah.
                </p>
                
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-yellow-400"></i>
                    <span>Pahala jariah yang berterusan</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-yellow-400"></i>
                    <span>Membantu pelajar asnaf</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-yellow-400"></i>
                    <span>Pembangunan infrastruktur madrasah</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-yellow-400"></i>
                    <span>Laporan kewangan yang telus</span>
                  </div>
                </div>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <h4 className="text-xl font-bold mb-4">Kaedah Sumbangan</h4>
                
                {donationMethods.map((method, index) => (
                  <div key={index} className="mb-4 pb-4 border-b border-white/20 last:border-0">
                    {method.link ? (
                      <a 
                        href={method.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 mb-2 hover:opacity-80 transition-opacity cursor-pointer"
                      >
                        <div className="w-10 h-10 flex items-center justify-center bg-yellow-500 rounded-full">
                          <i className={`${method.icon} text-xl text-emerald-900`}></i>
                        </div>
                        <h5 className="font-bold">{method.title}</h5>
                      </a>
                    ) : (
                      <div className="flex items-center gap-3 mb-2">
                        <div className="w-10 h-10 flex items-center justify-center bg-yellow-500 rounded-full">
                          <i className={`${method.icon} text-xl text-emerald-900`}></i>
                        </div>
                        <h5 className="font-bold">{method.title}</h5>
                      </div>
                    )}
                    
                    {method.bank && (
                      <div className="ml-13 text-emerald-100 text-sm">
                        <p>{method.bank}</p>
                        <p className="font-mono">{method.account}</p>
                        <p>{method.name}</p>
                      </div>
                    )}
                    
                    {method.details && (
                      <div className="ml-13 text-emerald-100 text-sm space-y-1">
                        {method.details.map((detail, idx) => (
                          <p key={idx}>{detail}</p>
                        ))}
                      </div>
                    )}
                    
                    {method.description && !method.link && (
                      <p className="ml-13 text-emerald-100 text-sm">{method.description}</p>
                    )}
                    
                    {method.description && method.link && (
                      <p className="ml-13 text-emerald-100 text-sm">{method.description}</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-2xl p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-yellow-500 rounded-full flex-shrink-0">
                  <i className="ri-hand-coin-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-emerald-900 mb-2">Program Wakaf & Endowmen</h3>
                  <p className="text-gray-700">Wakafkan harta anda untuk pembangunan madrasah yang berterusan</p>
                </div>
              </div>
              
              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <span>Wakaf tanah dan bangunan</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <span>Wakaf tunai untuk pendidikan</span>
                </li>
                <li className="flex items-start gap-2 text-gray-700">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-1"></i>
                  <span>Wakaf peralatan dan kemudahan</span>
                </li>
              </ul>
              
              <button 
                onClick={() => setShowWakafModal(true)}
                className="bg-emerald-700 text-white px-6 py-3 rounded-full font-semibold hover:bg-emerald-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                Maklumat Wakaf
              </button>
            </div>
            
            <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-emerald-700 rounded-full flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-emerald-900 mb-2">Penajaan Pelajar Tahfiz</h3>
                  <p className="text-gray-700">Tajakan seorang pelajar dan bantu mereka menjadi huffaz</p>
                </div>
              </div>
              
              <div className="space-y-3 mb-6">
                <div className="bg-white p-4 rounded-lg">
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-emerald-900">Tajaan Penuh (Setahun)</span>
                    <span className="font-bold text-emerald-700">RM 9,000</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-emerald-900">Tajaan Separuh (Setahun)</span>
                    <span className="font-bold text-emerald-700">RM 4,500</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-lg">
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-emerald-900">Tajaan Bulanan</span>
                    <span className="font-bold text-emerald-700">RM 750</span>
                  </div>
                </div>
              </div>
              
              <button className="bg-yellow-500 text-emerald-900 px-6 py-3 rounded-full font-semibold hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                Taja Pelajar
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Wakaf Modal */}
      {showWakafModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowWakafModal(false)}>
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-emerald-700 to-emerald-900 text-white p-6 rounded-t-3xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-yellow-500 rounded-full">
                    <i className="ri-hand-coin-line text-3xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold">Program Wakaf & Endowmen</h3>
                    <p className="text-emerald-100 text-sm">Pelaburan Akhirat Yang Berterusan</p>
                  </div>
                </div>
                <button 
                  onClick={() => setShowWakafModal(false)}
                  className="w-10 h-10 flex items-center justify-center hover:bg-white/20 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-3xl"></i>
                </button>
              </div>
            </div>

            <div className="p-8">
              <div className="mb-8">
                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-lg mb-6">
                  <div className="flex items-start gap-3">
                    <i className="ri-lightbulb-line text-2xl text-yellow-600 mt-1"></i>
                    <div>
                      <h4 className="font-bold text-emerald-900 mb-2">Apa itu Wakaf?</h4>
                      <p className="text-gray-700 leading-relaxed">
                        Wakaf adalah amalan menahan harta untuk tujuan kebajikan yang pahalanya mengalir secara berterusan. Wakaf untuk pendidikan tahfiz adalah salah satu amal jariah terbaik kerana ia melahirkan generasi penghafaz Al-Quran.
                      </p>
                    </div>
                  </div>
                </div>

                <h4 className="text-2xl font-bold text-emerald-900 mb-4">Jenis-jenis Wakaf</h4>
                
                <div className="grid md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-xl p-6 border-2 border-emerald-200">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-emerald-700 rounded-full">
                        <i className="ri-building-line text-xl text-white"></i>
                      </div>
                      <h5 className="text-xl font-bold text-emerald-900">Wakaf Tanah & Bangunan</h5>
                    </div>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-emerald-600 mt-1"></i>
                        <span>Tanah untuk pembangunan madrasah</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-emerald-600 mt-1"></i>
                        <span>Bangunan asrama pelajar</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-emerald-600 mt-1"></i>
                        <span>Dewan kuliah dan perpustakaan</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-emerald-600 mt-1"></i>
                        <span>Surau dan masjid</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-6 border-2 border-yellow-200">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-yellow-500 rounded-full">
                        <i className="ri-money-dollar-circle-line text-xl text-white"></i>
                      </div>
                      <h5 className="text-xl font-bold text-emerald-900">Wakaf Tunai</h5>
                    </div>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-yellow-600 mt-1"></i>
                        <span>Dana pendidikan pelajar asnaf</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-yellow-600 mt-1"></i>
                        <span>Biasiswa tahfiz berterusan</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-yellow-600 mt-1"></i>
                        <span>Gaji guru dan ustaz</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-yellow-600 mt-1"></i>
                        <span>Penyelenggaraan madrasah</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-6 border-2 border-teal-200">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-full">
                        <i className="ri-book-open-line text-xl text-white"></i>
                      </div>
                      <h5 className="text-xl font-bold text-emerald-900">Wakaf Peralatan</h5>
                    </div>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                        <span>Komputer dan tablet pembelajaran</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                        <span>Sistem audio dan PA</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                        <span>Perabot dan kelengkapan</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                        <span>Kenderaan pengangkutan</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-6 border-2 border-orange-200">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-full">
                        <i className="ri-book-2-line text-xl text-white"></i>
                      </div>
                      <h5 className="text-xl font-bold text-emerald-900">Wakaf Al-Quran</h5>
                    </div>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                        <span>Mushaf Al-Quran untuk pelajar</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                        <span>Kitab-kitab rujukan</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                        <span>Buku-buku ilmiah Islam</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                        <span>Koleksi perpustakaan digital</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-emerald-700 to-emerald-900 rounded-xl p-8 text-white mb-8">
                  <h4 className="text-2xl font-bold mb-6 flex items-center gap-3">
                    <i className="ri-gift-line text-3xl text-yellow-400"></i>
                    Kelebihan Berwakaf
                  </h4>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-2xl text-yellow-400 mt-1"></i>
                      <div>
                        <h5 className="font-bold mb-1">Pahala Jariah Berterusan</h5>
                        <p className="text-emerald-100 text-sm">Pahala mengalir selagi wakaf dimanfaatkan</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-2xl text-yellow-400 mt-1"></i>
                      <div>
                        <h5 className="font-bold mb-1">Pelaburan Akhirat</h5>
                        <p className="text-emerald-100 text-sm">Simpanan yang tidak akan habis di akhirat</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-2xl text-yellow-400 mt-1"></i>
                      <div>
                        <h5 className="font-bold mb-1">Melahirkan Huffaz</h5>
                        <p className="text-emerald-100 text-sm">Turut sama melahirkan penghafaz Al-Quran</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-check-double-line text-2xl text-yellow-400 mt-1"></i>
                      <div>
                        <h5 className="font-bold mb-1">Keberkatan Harta</h5>
                        <p className="text-emerald-100 text-sm">Harta yang diberkati Allah SWT</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6 mb-6">
                  <h4 className="text-xl font-bold text-emerald-900 mb-4 flex items-center gap-2">
                    <i className="ri-information-line text-2xl text-emerald-700"></i>
                    Cara Mewakafkan Harta
                  </h4>
                  <ol className="space-y-3">
                    <li className="flex items-start gap-3">
                      <span className="w-8 h-8 flex items-center justify-center bg-emerald-700 text-white rounded-full font-bold flex-shrink-0">1</span>
                      <div>
                        <h5 className="font-bold text-emerald-900">Hubungi Kami</h5>
                        <p className="text-gray-600 text-sm">Buat temujanji untuk perbincangan wakaf</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-8 h-8 flex items-center justify-center bg-emerald-700 text-white rounded-full font-bold flex-shrink-0">2</span>
                      <div>
                        <h5 className="font-bold text-emerald-900">Perbincangan & Nasihat</h5>
                        <p className="text-gray-600 text-sm">Dapatkan nasihat tentang jenis wakaf yang sesuai</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-8 h-8 flex items-center justify-center bg-emerald-700 text-white rounded-full font-bold flex-shrink-0">3</span>
                      <div>
                        <h5 className="font-bold text-emerald-900">Dokumentasi</h5>
                        <p className="text-gray-600 text-sm">Lengkapkan dokumen wakaf mengikut syariah</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-8 h-8 flex items-center justify-center bg-emerald-700 text-white rounded-full font-bold flex-shrink-0">4</span>
                      <div>
                        <h5 className="font-bold text-emerald-900">Penyerahan & Sijil</h5>
                        <p className="text-gray-600 text-sm">Terima sijil wakaf dan laporan penggunaan</p>
                      </div>
                    </li>
                  </ol>
                </div>

                <div className="bg-yellow-50 border-2 border-yellow-300 rounded-xl p-6">
                  <div className="flex items-start gap-3 mb-4">
                    <i className="ri-phone-line text-3xl text-emerald-700"></i>
                    <div>
                      <h4 className="text-xl font-bold text-emerald-900 mb-2">Hubungi Kami Untuk Maklumat Lanjut</h4>
                      <p className="text-gray-700 mb-4">Pasukan kami sedia membantu anda dalam proses wakaf</p>
                      <div className="space-y-2 text-gray-700">
                        <p className="flex items-center gap-2">
                          <i className="ri-phone-fill text-emerald-700"></i>
                          <strong>Telefon:</strong> +60 6-910 2805
                        </p>
                        <p className="flex items-center gap-2">
                          <i className="ri-whatsapp-fill text-emerald-700"></i>
                          <strong>WhatsApp:</strong> +60 19-733 4434
                        </p>
                        <p className="flex items-center gap-2">
                          <i className="ri-mail-fill text-emerald-700"></i>
                          <strong>Email:</strong> badankebajikanzawiyahjohor@gmail.com
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-4 justify-end">
                <button 
                  onClick={() => setShowWakafModal(false)}
                  className="px-8 py-3 bg-gray-200 text-gray-700 rounded-full font-semibold hover:bg-gray-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Tutup
                </button>
                <a 
                  href="#hubungi"
                  onClick={() => setShowWakafModal(false)}
                  className="px-8 py-3 bg-emerald-700 text-white rounded-full font-semibold hover:bg-emerald-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Hubungi Sekarang
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
